module.exports = __webpack_public_path__ + "img/Coming Soon Products Pastel Brown Instagram Post.840692e1.png";